
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const timeDate = require('../../../../../production/js-handler/time-date')

export const tableDetail = {
    entity: 'sale',//name table on the db
    dest: 'sale',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"warehousesale", "elem":"fullcont", "id":"warehousesale-fullcont", "act":"selectOne", "entity":"sale", "dbid": "#dbid"}  ],
                                
                                "clickRight": [{"dest":"sale", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"sale", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["sale.code","customer.name"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ 
    //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Result', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' } ]})
        return newData
    }

    data.forEach((elem)=>{
        
        newData.push(
                {   id: elem.id,   colum: [  { label: elem.name, span: elem.purchaseCodeREF_tdW,  style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.avatar,
                                                avatarColor: '', 
                                                avatarColorLetter: '', 
                                                avatarLetter: ''  
                                                
                                              } },
                                              { label: timeDate.friendlyDate(elem.sale_date),   span: '' },
                                              { label: elem.grand_total,   span: '' }
                                        ]    
                }
        )/*push*/
    })/*forEach*/
    
    return newData
}/*organizeRow*/